import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faq } from "@/data/faq";

export default function FAQ() {
  return (
    <section className="bg-brand-page py-14 md:py-20" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="overline">FAQ</div>
            <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl mt-3 text-brand-ink leading-[1.05]">
              Questions fréquentes
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Tout ce qu'il faut savoir sur nos formations IA, leur financement et leur déroulement.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {faq.map((item, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-line">
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    className="text-left font-heading font-semibold text-base md:text-lg text-brand-ink py-5 hover:text-brand-blue hover:no-underline"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pb-5 text-base">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
